if (!customElements.get('address-country')) {
    customElements.define('address-country', class AddressCountry extends HTMLElement {
        constructor() {
            super();

            this.select = this.querySelector('select');
            this.customSelect = this.querySelector('.js-select-wrap');
            this.provincesSelectBlock = this.closest('form').querySelector('.js-provinces-select-wrap');
            this.initSelect();
            this.select.addEventListener('change',this.selectChange.bind(this))
        }
        initSelect(){
            let select = this.select;
            let optionsList = select.querySelectorAll('option');
            let customSelectOptionsList = this.customSelect.querySelector('.js-select-list');
            optionsList.forEach(option => {
                if(option.value !== "---"){
                    let customOptionBlock = document.createElement("div");
                    customOptionBlock.classList.add("select-item");
                    customOptionBlock.setAttribute("data-value", option.value);
                    customOptionBlock.innerHTML = option.innerHTML;
                    customSelectOptionsList.appendChild(customOptionBlock);
                }
            });

            let customSelectOptions = this.customSelect.querySelectorAll('.select-item');
            customSelectOptions.forEach(function (item){
                item.addEventListener('click', function (){
                    select.value = select.querySelector(`option[value="${item.dataset.value}"]`).value;
                    select.dispatchEvent(new Event('change'));
                });
            })
        }
        // provinces
        selectChange(){
            let provincesSelectBlock = this.provincesSelectBlock;
            let selectedOption = this.select.options[this.select.selectedIndex];
            let dataProvinces = selectedOption.dataset.provinces;
            let provinces = JSON.parse(dataProvinces);
            if(provinces && provinces.length == 0){
                provincesSelect.style.display = 'none';
            }else{
                let provinceSelect = this.provincesSelectBlock.querySelector('select');
                let provinceCustomSelectList = this.provincesSelectBlock.querySelector('.js-provinces-select-list');

                provinces.forEach(item =>{
                    let customOptionBlock = document.createElement("div");
                    customOptionBlock.classList.add("select-item");
                    customOptionBlock.setAttribute("data-value", item[0]);
                    customOptionBlock.innerHTML = item[1];
                    provinceCustomSelectList.appendChild(customOptionBlock);
                    let optionBlock = document.createElement('option');
                    optionBlock.value = item[0];
                    optionBlock.innerHTML = item[0];
                    provinceSelect.appendChild(optionBlock);
                });
                provincesSelectBlock.style.display = 'block';
                this.reloadEvents();
                let customSelectOptions = provinceCustomSelectList.querySelectorAll('.select-item');
                customSelectOptions.forEach(function (item){
                    item.addEventListener('click', function (){
                        provinceSelect.value = provinceSelect.querySelector(`option[value="${item.dataset.value}"]`).value;
                        provinceSelect.dispatchEvent(new Event('change'));
                    });
                })
            }
        }
        reloadEvents(){
            var selectElements = $(".js-provinces-select-wrap .custom-select");
            selectElements.each(function () {
                var $select = $(this);
                var $selectActive = $select.find(".select-active");
                var $selectActiveText = $selectActive.find("span");
                var $selectList = $select.find(".select-list");
                var $selectItem = $selectList.find(".select-item");
                var $selectInput = $select.find("select");
                var $selectInputItems = $selectInput.find("option");
                $selectItem.on("click", function (evt) {
                    var $item = $(this);
                    var itemAttr = $item.attr("data-value");
                    $selectInputItems.each(function () {
                        var inputItemAttr = $(this).attr("value");
                        if (itemAttr === inputItemAttr) {
                            $selectInput.val(itemAttr);
                            $selectActiveText.text($item.text())
                        }
                    });
                    $selectItem.not($(this)).removeClass("selected-item");
                    $(this).addClass("selected-item");
                    $select.toggleClass("active");
                    $selectList.slideToggle()
                });
            })
        }
    });
}

let deleteAddressButtons = document.querySelectorAll('.js-delete-address');
if(deleteAddressButtons){
    deleteAddressButtons.forEach(button => {
       button.addEventListener('click',function (){
           if (confirm(this.getAttribute('data-confirm-message'))) {
               Shopify.postLink(this.dataset.target, {
                   parameters: { _method: 'delete' },
               });
           }
       });
    });
}
let toggleAddressForm = document.querySelectorAll('.js-toggle-form-address');
if(toggleAddressForm){
    toggleAddressForm.forEach(button => {
       button.addEventListener('click',function (){
           let formId = this.getAttribute('data-address-form-id');
           $(`#${formId}`).slideToggle();
       });
    });
}
let toggleAddAddressForm = document.querySelectorAll('.js-toggle-add-form');
if(toggleAddAddressForm){
    toggleAddAddressForm.forEach(button => {
       button.addEventListener('click',function (){
           let formId = this.getAttribute('data-form-id');
           $(`#${formId}`).slideToggle();
       });
    });
}